import { getAppVersion } from '@/utils/general';

const init = () => {
  const version = getAppVersion();
  const release = version && !version.startsWith('{') ? `Version: ${version}` : '';
  // eslint-disable-next-line no-console
  console.log(`
████████    ████████    ████████
████████    ████████    ████████
████████    ████████    ████████
████████    ████████    ████████
████████    ████████    ████████
████████    ████████    ████████
████████    ████████    ████████
████████    ████████    ████████
      ████████    ████████
      ████████    ████████
      ████████    ████████
      ████████    ████████
  ${release}
`);
};

export default init;
